module.exports = __webpack_public_path__ + "media/images/common/main_t_l-fc39d6c2ef223b796e9260c15b0aaa24.gif";